import { render } from "./HelloWorld.vue?vue&type=template&id=9d81157c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=9d81157c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d81157c"

export default script